@if (component) {
  <oe-modal-line [name]="component.alias ?? component.id" [channelAddress]="component.id + '/ActivePower'"
    [converter]="Utils.CONVERT_TO_WATT">
  </oe-modal-line>
  <oe-modal-meter-phases [component]="component"></oe-modal-meter-phases>
}
